/* Small formatting helpers. */

/* Face match distance -> friendly percentage.
   0.0 distance = identical (100%); >= 1.0 = no similarity (0%).
   The raw Euclidean distance stays authoritative in the API/CSV. */
export function matchPercent(score) {
  if (score == null) return null;
  return Math.round(Math.max(0, Math.min(1, 1 - score)) * 100);
}

export function mapsUrl(lat, lng) {
  return `https://www.google.com/maps?q=${lat},${lng}`;
}
